import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { InvestisseurService } from './investisseur.service';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private readonly document = inject(DOCUMENT);
  private readonly investisseurService = inject(InvestisseurService);
  private readonly defaultPageTitle = this.document?.title?.trim() || 'Proxeema';

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);

    if (routeTitle) {
      this.titleService.setTitle(routeTitle);
      return;
    }

    const activePrimaryRoute = this.getActivePrimaryRoute(snapshot.root);
    const isInvestisseurDetailsPage = activePrimaryRoute.pathFromRoot.some(
      route => route.data?.['useInvestisseurDetailsPageTitle'] === true
    );

    if (isInvestisseurDetailsPage) {
      const investisseurName = this.investisseurService.investisseurNameSig();
      this.titleService.setTitle(`${this.defaultPageTitle} - ${investisseurName}`);
      return;
    }

    this.titleService.setTitle(this.defaultPageTitle);
  }

  private getActivePrimaryRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let currentRoute = route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    return currentRoute;
  }
}
